// Rank-b2c.jsx
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Grid, Image, Stepper, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import BadgeSVG from '../../assets/images/dashboard/badge.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

const Rank = ({ props }) => {

    const [isCurrent, setIsCurrent] = React.useState([false, false, false]);
    const [nightReservesCount, setNightReservesCount] = React.useState(0);
    const [userPlanDetails, setUserPlanDetails] = React.useState('loading');

    React.useEffect(() => {
        if (props.userPlanDetails.status === 200) {
            setUserPlanDetails(props.userPlanDetails.data);
        }
        if (props.nightReservesCount.status === 200) {
            setNightReservesCount(props.nightReservesCount.data);
        }
        if (userPlanDetails !== 'loading' && nightReservesCount !== 0) {
            userPlanDetails.forEach((obj, index) => {
                if (Math.ceil(obj.MinValue) <= nightReservesCount) {
                    if (index === 0) {
                        setIsCurrent(['active', false, false]);
                    } else if (index === 1) {
                        setIsCurrent(['active', 'active', false]);
                    } else if (index === 2) {
                        setIsCurrent(['active', 'active', 'active']);
                    }
                }
            });
        }
    }, [props, nightReservesCount, userPlanDetails]);

    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper
                    className={`align-item-center p-xl bg-white rounded-lg border-solid border-light`}>
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                        <React.Fragment>
                            <Grid.Item
                                size='col-12 md-4'>
                                <Image
                                    className={`mx-auto`}
                                    src={BadgeSVG}
                                    alt='rank'
                                    ms={{
                                        width: '97px',
                                        height: 'auto'
                                    }} />
                                <Box
                                    className={`my-lg mt-0`} />
                                <Box
                                    className={`d-block text-center`}>
                                    <Typography
                                        className={`text-center`}>
                                        سطح فعلی شما
                                    </Typography> <Typography
                                        className={`text-primary`}>
                                        {userPlanDetails !== 'loading' && userPlanDetails.map((obj, index) => (
                                            <React.Fragment key={index}>
                                                {obj.IsCurrent && (
                                                    <Typography className={`text-primary`} component='strong'>
                                                        {obj.Title}
                                                    </Typography>
                                                )}
                                            </React.Fragment>
                                        ))} {userPlanDetails === 'loading' &&
                                            <Image
                                                className={`d-inline`}
                                                src={LoadingCustomSVG}
                                                ms={{
                                                    width: '20px',
                                                    height: '20px'
                                                }} />
                                        }
                                    </Typography> <Typography>
                                        قرار دارید.
                                    </Typography>
                                </Box>
                            </Grid.Item>
                            <Grid.Item
                                className={`position-relative`}
                                size='col-1'>
                                <Box
                                    className={`position-absolute transform-center bg-gray-light`}
                                    ms={{
                                        width: '1px',
                                        height: '80px'
                                    }} />
                            </Grid.Item>
                            <Grid.Item
                                size='col-7'>
                                <Box
                                    className={`h-100 position-relative`}>
                                    <Box
                                        className={`w-100 position-absolute transform-center`}>
                                        <Box
                                            className={`d-flex justify-content-between`}>
                                            <Typography component='strong'>
                                                مجموع کل رزروهای شما
                                            </Typography>
                                            <Typography component='small'>
                                                {nightReservesCount !== 0 &&
                                                    <React.Fragment>
                                                        {nightReservesCount} رزرو
                                                    </React.Fragment>
                                                }
                                                {nightReservesCount === 0 &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`my-xxl mt-0`} />
                                        <Stepper>
                                            <Stepper.Item active={isCurrent[0]}>
                                                <Typography component='small' className={isCurrent[0] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[0] === false ? { color: '#6F6F7E' } : {}}>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[0]?.Title}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                </Typography>
                                                <Typography component='small'>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[0]?.MinValue}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                    &nbsp;رزرو
                                                </Typography>
                                            </Stepper.Item>
                                            <Stepper.Item active={isCurrent[1]}>
                                                <Typography component='small' className={isCurrent[1] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[1] === false ? { color: '#6F6F7E' } : {}}>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[1]?.Title}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                </Typography>
                                                <Typography component='small'>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[1]?.MinValue}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                    &nbsp;رزرو
                                                </Typography>
                                            </Stepper.Item>
                                            <Stepper.Item active={isCurrent[2]}>
                                                <Typography component='small' className={isCurrent[2] === 'active' ? 'd-block text-bold' : 'd-block'} ms={isCurrent[2] === false ? { color: '#6F6F7E' } : {}}>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[2]?.Title}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                </Typography>
                                                <Typography component='small'>
                                                    {userPlanDetails !== 'loading' && userPlanDetails[2]?.MinValue}
                                                    {userPlanDetails === 'loading' && <Image className={`d-inline`} src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} />}
                                                    &nbsp;رزرو
                                                </Typography>
                                            </Stepper.Item>
                                        </Stepper>
                                    </Box>
                                </Box>
                            </Grid.Item>
                        </React.Fragment>
                    }
                    {scale === 'x-small' &&
                        <React.Fragment>
                            <Grid.Item
                                size='col-8'
                                className={`align-self-center`}>
                                <Typography className={`p-sm`}>
                                    شما در سطح   {userPlanDetails !== 'loading' && userPlanDetails.map((obj, index) => (
                                        <React.Fragment key={index}>
                                            {obj.IsCurrent && (
                                                <Typography className={`text-primary`} component='strong'>
                                                    {obj.Title}
                                                </Typography>
                                            )}
                                        </React.Fragment>
                                    ))} {userPlanDetails === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        } قرار دارید.
                                </Typography>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Box>
                                    <Image
                                        src={BadgeSVG}
                                        ms={{
                                            width: '82px'
                                        }} />
                                </Box>
                            </Grid.Item>
                        </React.Fragment>
                    }
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );
};

export default Rank;